import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';

export const selectPermission = (state: RootState) =>
  state.permission || {
    permissions: [],
    loading: false,
    error: null,
  };

export const selectPermissions = createSelector(
  [selectPermission],
  state => state.permissions,
);

export const selectPermissionLoading = createSelector(
  [selectPermission],
  state => state.loading,
);

export const selectPermissionError = createSelector(
  [selectPermission],
  state => state.error,
);

export const makeSelectHasPermission = () =>
  createSelector(
    [selectPermissions, (_, permissionId: string) => permissionId],
    (permissions, permissionId) => {
      if (!permissionId) return true;
      return permissions.some(p => p.id === permissionId);
    },
  );
